"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowAction = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.RowAction = (0, styled_components_1.default)(ui_butticon_1.Butticon).attrs({
  size: 'small'
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var templateObject_1;